import type { GroupedTechnologies } from "../types/model";

export const EMPTY_GROUPED_TECHNOLOGIES: GroupedTechnologies = { categories: [], subCategories: [], technologies: [] };
